import { useQuery } from "@tanstack/react-query";
import { GET_LOGO } from "../api/queries";
import { graphQLClient } from "../graphqlClient";

const fetchLogo = async ({ queryKey }) => {
  const [, { districtID }] = queryKey;
  const { getLogo } = await graphQLClient.request(GET_LOGO, { districtID });
  return getLogo; // Returns { svg, error }
};

export const useGetDistrictLogo = (districtID, enabled = true) => {
  return useQuery({
    queryKey: districtID ? ["getLogo", { districtID }] : null,
    queryFn: fetchLogo,
    enabled: !!districtID && enabled,
  });
};
